<app-navbar [type]="navbarTypeEnum.LANDING" [isCheckout]="false" />
<section class="body-font relative flex flex-col justify-center items-center">
  <div
    class="sm:px-2 sm:py-4 justify-center self-center flex sm:flex-nowrap flex-wrap"
  >
    <div
      class="shadow-xl mx-auto sm:rounded-3xl bg-surface overflow-hidden flex relative"
    >
      <div class="w-full h-full max-w-7xl">
        <div class="flex flex-col items-start h-fit px-4 sm:px-16 py-8">
          <h1
            class="text-4xl font-bold pb-8 border-b-4 border-primary w-full pl-16 -ml-16"
          >
            Atención al cliente.
          </h1>
          <ml-breadcrumb [items]="breadcrumbItems" class="mt-4" />
          <p class="text-lg mt-6">
            Aquí encontrarás información sobre cómo contactar con nosotros, las
            respuestas a las preguntas más frecuentes en un solo clic.
          </p>
          <div class="pt-6 md:pt-10">
            <div class="px-3 md:container">
              <div class="lg:flex">
                <div class="items-center lg:hidden">
                  <select
                    (change)="onSelectOption($event)"
                    [(ngModel)]="selectedOption"
                    class="mx-2 mb-8 px-4.5 py-2.5 rounded-md h-full w-[-webkit-fill-available] text-xl focus:ring-2 focus:ring-inset focus:ring-primary block border-0 bg-bg text-fg shadow-sm ring-1 ring-inset ring-border-strong"
                  >
                    <option
                      class="text-base"
                      value="/atencion-cliente/preguntas-frecuentes"
                    >
                      Preguntas frecuentes
                    </option>
                    <option value="/atencion-cliente/contactanos">
                      Contáctanos
                    </option>
                    <option value="/atencion-cliente/nosotros">Nosotros</option>
                    <option value="/atencion-cliente/como-funciona">
                      Cómo funciona
                    </option>
                    <option value="/atencion-cliente/envio-y-entrega">
                      Envío y Entrega
                    </option>
                    <option value="/atencion-cliente/cambio">
                      Solicitud de cambio
                    </option>
                    <option value="/atencion-cliente/pausar-cancelar">
                      Pausar y cancelar
                    </option>
                    <option value="/atencion-cliente/pago">Pago</option>
                    <option value="/atencion-cliente/programa-loyalty">
                      Programa de Lealtad
                    </option>
                    <option value="/atencion-cliente/promociones">
                      Promociones
                    </option>
                  </select>
                </div>
                <div class="left-flex hidden lg:block mr-10 mb-10">
                  <div class="mt-3 px-6">
                    <a
                      routerLink="preguntas-frecuentes"
                      routerLinkActive="font-bold text-primary"
                      aria-current="page"
                      class="ota-body-light nuxt-link-exact-active nuxt-link-active"
                    >
                      Preguntas frecuentes
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="contactanos"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Contáctanos
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="nosotros"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Nosotros
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="/atencion-cliente/como-funciona"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Cómo funciona
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="envio-y-entrega"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Envío y Entrega
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="cambio"
                      aria-current="page"
                      class="ota-body-light nuxt-link-exact-active nuxt-link-active"
                      routerLinkActive="font-semibold text-primary"
                    >
                      Solicitud de cambio
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="pausar-cancelar"
                      class="ota-body-light"
                      routerLinkActive="font-semibold text-primary"
                    >
                      Pausar y cancelar
                    </a>
                  </div>
                  <!-- <div class="mt-3 px-6"><a routerLink="es-es/men/customer-service/change-details" class="ota-body-light">
                                            Cambiar datos
                                        </a></div> -->
                  <div class="mt-3 px-6">
                    <a
                      routerLink="pago"
                      class="ota-body-light"
                      routerLinkActive="font-semibold text-primary"
                    >
                      Pago
                    </a>
                  </div>
                  <!-- <div class="mt-3 px-6"><a routerLink="es-es/men/customer-service/boxershorts" class="ota-body-light">
                                            Información del producto
                                        </a></div> -->
                  <!-- <div class="mt-3 px-6"><a routerLink="es-es/men/customer-service/extra" class="ota-body-light">
                                            Adicional
                                        </a></div> -->
                  <div class="mt-3 px-6">
                    <a
                      routerLink="programa-loyalty"
                      class="ota-body-light"
                      routerLinkActive="font-semibold text-primary"
                    >
                      Programa de Lealtad
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="promociones"
                      class="ota-body-light"
                      routerLinkActive="font-semibold text-primary"
                    >
                      Promociones
                    </a>
                  </div>
                </div>
                <div class="flex">
                  <div class="mx-auto sm:max-w-2xl px-2 lg:px-8">
                    <router-outlet></router-outlet>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer />
